import dayjs from 'dayjs';

export interface ICatalogoInstitucion {
  id?: number;
  claveInstitucion?: string | null;
  nombreCorto?: string;
  createdDate?: dayjs.Dayjs | null;
}

export const defaultValue: Readonly<ICatalogoInstitucion> = {};
